export enum UserServiceQueryKeys {
  CHECK_PHONE_NO = 'CHECK_PHONE_NO',
  GET_USER_PROFILE = 'GET_USER_PROFILE',
  GET_USERS_LIST = 'GET_USERS_LIST',
  GET_USER_INFO = 'GET_USER_INFO',
  GET_LEADERS_LIST = 'GET_LEADERS_LIST',
  GET_MERCHANT_OIL_LIST = 'GET_MERCHANT_OIL_LIST',
  GET_ADMIN_ACTIONS = 'GET_ADMIN_ACTIONS',
  GET_FINANCIAL_LIMIT_OPTIONS = 'GET_FINANCIAL_LIMIT_OPTIONS',
}

export enum CompanyWalletServiceQueryKeys {
  GET_COMPANY_INFO = 'GET_COMPANY_INFO',
}

export enum TransactionServiceQueryKeys {
  GET_USER_BALANCE = 'GET_USER_BALANCE',
  GET_BANK_INFO = 'GET_BANK_INFO',
}

export enum ManagementServiceQueryKeys {
  GET_MANAGEMENT_LIST = 'GET_MANAGEMENT_LIST',
}

export enum AuditLogsServiceQueryKeys {
  GET_AUDIT_LOGS_LIST = 'GET_AUDIT_LOGS_LIST',
}
